import React from 'react';
import { ChevronRightIcon, BookOpenIcon } from 'lucide-react';
interface DeepDiveCardProps {
  icon?: React.ReactNode;
  title: string;
  subtitle: string;
  onExplore?: () => void;
}
export function DeepDiveCard({
  icon = <BookOpenIcon className="w-6 h-6 text-roche-blue" data-id="element-16" />,
  title,
  subtitle,
  onExplore
}: DeepDiveCardProps) {
  return <div className="px-6 py-6" data-id="element-17">
      <button onClick={onExplore} className="w-full bg-cream-bg border border-border-gray rounded-lg p-5 flex items-center gap-4 transition-smooth active:scale-[0.98]" aria-label={`Explore: ${title}`} data-id="element-18">
        {/* Icon */}
        <div className="flex-shrink-0" data-id="element-19">{icon}</div>

        {/* Content */}
        <div className="flex-1 text-left" data-id="element-20">
          <h4 className="font-semibold text-text-primary mb-1" data-id="element-21">{title}</h4>
          <p className="text-sm text-text-secondary" data-id="element-22">{subtitle}</p>
        </div>

        {/* Arrow */}
        <div className="flex-shrink-0" data-id="element-23">
          <div className="flex items-center gap-1 text-roche-blue font-semibold text-sm" data-id="element-24">
            <span data-id="element-25">Explore</span>
            <ChevronRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-26" />
          </div>
        </div>
      </button>
    </div>;
}